<template>
    <div>
        <el-dialog
             append-to-body
                :fullscreen="dialogFull"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                :before-close="handleClose"
                title="回 访"
                top="30px"
                :visible.sync="dialogShow"
                width="50%"
            :modal-append-to-body="false">
            <template slot="title">
                    <div class="avue-crud__dialog__header">
                            <span class="el-dialog__title">
                                   回 访
                            </span>
                            <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                            
                    </div>
                    <el-divider></el-divider>
            </template>
            <div style="max-height:calc(100vh - 320px);overflow-y:scroll;overflow-x:hidden;">
            <avue-form 
                v-if="dialogShow"
                :option="visitFormOption"
                v-model="form"
                ref="form"
                @submit="formSubmit"
                @error="formError">
                <template slot="target">
                        <div>
                            <el-tag type="success">标签二</el-tag>
                        </div>
                    </template>
                 <template slot="remark">
                        <div>
                            <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入内容"
                                v-model="form.remark">
                            </el-input>
                            <remarkModel :remark.sync="form.remark" ref="scrapFormRemarkModel"></remarkModel>
                        </div>
                    </template>
               
                <!-- <template slot="menuForm">
                    <el-button @click="handleClose" ><span class="el-icon-close"></span> 取消</el-button>
                </template> -->
            </avue-form>
            </div>
            <template slot="footer"> 
                <el-button @click="formSubmit1" size="small" type="primary"><span class="el-icon-check"></span> 保存</el-button>
                <el-button @click="handleClose" size="small" style="margin-right:15px"><span class="el-icon-close" ></span> 取消</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import {
  
    visitFormOption,
} from "./course-dialog-form-option";
import remarkModel from "./remark-model";
import {getProjectDict} from "@/api/crmedical/project-dictionary/project-dictionary";
import { returnVisit} from "@/api/gateservice/order/order-list/order-list";
export default {
    components:{
        remarkModel
    },
    data(){
        return{
            dialogFull:false,
            form:{
                target:[122],
                detailList:[]
            },
            cheackedPeople:[],
            userList:[],
            dialogShow:false,
            visitFormOption:visitFormOption,
            projectId:'',
            orderId:'',
            evaluateList:[],
        }
    },
    created(){
        
    },
    methods:{
        // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {
                        
                        self.dialogShow = false;
                        
                })
                .catch(()=> {
                        
                });
        },
        openDialog(orderId,projectId){
            this.dialogShow = true;
            this.projectId = projectId;
            this.orderId = orderId;
            this.form = {
                 detailList:[]
            }
            this.getProjectDict();


        },
        getProjectDict(){
            // 获取评价对象
            getProjectDict({projectId:this.projectId,code:"project_order_evaluate_target"}).then(res=>{
               
                 let temArr = [];
                res.data.forEach(ele=>{
                    let temObj = {
                                type: 'rate',
                                label: ele.dictValue,
                                span: 12,
                                display: true,
                                max: 5,
                                required:true,
                                rules: [
                                        {
                                            required: true,
                                            message: '请评价',
                                            trigger:'blur'
                                        }
                                    ],
                                value: 0,
                                texts: [
                                    '很差',
                                    '差',
                                    '一般',
                                    '好',
                                    '很好'
                                ],
                                colors: [
                                    '#99A9BF',
                                    '#F7BA2A',
                                    '#FF9900'
                                ],
                                prop: ele.dictKey,
                                showText: true
                            }
                       
                            temArr.push(temObj)
                    })
                    console.log(123)
                    this.visitFormOption.column = [...this.visitFormOption.column1,...temArr,...this.visitFormOption.column2]
                         this.evaluateList = res.data;
                     // 获取服务标签
                getProjectDict({projectId:this.projectId,code:"project_order_service_target"}).then(res=>{
                    const column = this.findObject(this.visitFormOption.column, "target");
                    column.dicData = res.data;
                   
                    
                })
            })
           

        },
        closeDialog(){
            this.dialogShow = false;
        },
        formError(done){
            done();
        },
        formSubmit1(){
      this.$refs.form.submit();
    },
        formSubmit(form,done){
            form.detailList = [];
            this.visitFormOption.column.forEach(ele=>{
                if(ele.prop!='content' && ele.prop!='target' && ele.prop!='satisfaction' && ele.prop!='way' && ele.prop!='remark'){
                    let temObj = {target:ele.prop,level:form[ele.prop]};
                    form.detailList.push(temObj);
                }
            })
            if(form.detailList.length==0){
                 this.$message({
                        message: "缺少打分项",
                        type: 'warning'
                    });
                    done()
                return;
            }
            let contentFlag = false;
            for(let i = 0;i<form.detailList.length;i++){
                if((!form.detailList[i].level || form.detailList[i].level<1) && i<this.evaluateList.length){
                    debugger;
                    this.$message({
                        message: `请评价 ${this.evaluateList[i].dictValue}`,
                        type: 'warning'
                    });
                    done()
                    return;
                }
              
                if(form[this.evaluateList[i].dictKey]<3){
                    contentFlag = true;
                }
            }
            if(contentFlag){
                if(!form.remark){
                    this.$message({
                        message: '请填写差评信息',
                        type: 'warning'
                    });
                    done()
                    return;
                }
            }
            if(!this.form.target){
                this.form.target =[];
            }
            form.targets = this.form.target.join(',');
            form.orderId = this.orderId;
            // return;
            returnVisit(form).then(res=>{
                if(res.msg=='操作成功'){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                   this.dialogVisible = false;
                     this.dialogShow = false;
                    
                }else{
                    this.$message.error(res.msg);
                }
                
                this.$emit('handleClose',function(){console.log('关闭历程表')})
                
                this.dialogShow = false;
                done()
            }).catch(err=>{
               
                
                 done()
            })
        },
    }
}
</script>
